export const roles = {
    SAAS_MANAGER: 'saas_manager',
    PMF_SUPPORT: 'saas_manager',
    OWNER: 'owner',
    ADMIN: 'admin',
    CLIENT: 'client',
    ACCOUNT_MANAGER: 'account_manager',
    SUPERVISOR: 'supervisor',
    MECHANIC: 'mechanic',
    VENDOR: 'vendor'
}

export const roleInfo = {
    [roles.PMF_SUPPORT]: {
        label: "PMF Support"
    },
    [roles.SAAS_MANAGER]: {
        label: "SAAS Manager"
    },
    [roles.OWNER]: {
        label: "Owner"
    },
    [roles.ADMIN]: {
        label: "Admin"
    },
    [roles.CLIENT]: {
        label: "Client"
    },
    [roles.ACCOUNT_MANAGER]: {
        label: "Account Manager"
    },
    [roles.MECHANIC]: {
        label: "Mechanic"
    },
    [roles.SUPERVISOR]: {
        label: "Supervisor"
    },
    [roles.VENDOR]: {
        label: "Vendor"
    },
}